import React, { useEffect, useMemo, useState } from "react";
import { HiOutlineUpload } from "react-icons/hi";
import { GetCrawlLink, ProcessCrawlDmain } from "../../../../apis";
import InfiniteScrollUrls from "../../../../components/InfiniteScrollUrls";
import { IoLinkSharp } from "react-icons/io5";
import { FiGlobe } from "react-icons/fi";
import { fetchSitemapUrls } from "../../../../utils";
import { ImSpinner2 } from "react-icons/im";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { InfiniteScrollForUsedUrls } from "../../../../components";
import CatchCrawlRes from "../../../../apis/CatchCrawlRes";
import RemoveCatchCrawlRes from "../../../../apis/RemoveCatchCrawlRes";

const modes = [
  { key: "crawl", label: "Crawl Domain" },
  // { key: "sitemap", label: "Sitemap" },
  { key: "link", label: "Individual link" },
];

const pdf_modes = [
  { key: "pdf", label: "Upload from Device" },
  { key: "link", label: "Individual link" },
];

const ActiveTool = ({
  dispatch,
  state,
  activeTool,
  IoInformationCircleOutline,
  handelTrain,
}) => {
  const [mode, setMode] = useState({ link: "crawl", pdf: "pdf" }); // 'link' or 'sitemap'
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("atoz");

  const [link, setLink] = useState("");
  const [protocol, setProtocol] = useState("https");

  const [dragActive, setDragActive] = useState(false);

  const isPDF = (file) => file.type === "application/pdf";

  const bot_id = state?.selectedBot?.botId || "";
  const botData = state.botResources[bot_id] || {};

  const handleInputChange = (e) => {
    const value = e.target.value.trim();
    if (value.startsWith("https://")) {
      setProtocol("https");
      setLink(value.replace("https://", ""));
    } else if (value.startsWith("http://")) {
      setProtocol("http");
      setLink(value.replace("http://", ""));
    } else {
      setLink(value);
    }
  };

  const handelIndividualLink = () => {
    const fullURL = `${protocol}://${link}`;
    const urlPattern =
      /^(http|https):\/\/([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

    if (!urlPattern.test(fullURL)) {
      alert("Please enter a valid URL");
      return;
    }
    dispatch({
      type: "UPDATE_BOT_RESOURCE",
      payload: {
        botId: bot_id,
        data: {
          urls: [
            ...(botData?.urls || []),
            { type: "individual", domain: fullURL, data: fullURL },
          ],
          selectedUrls: [...(botData?.selectedUrls || []), fullURL],
        },
      },
    });

    // dispatch({
    //   type: "setUrls",
    //   payload: { type: "individual", domain: fullURL, data: fullURL },
    // });
    setLink("");
    return;
  };

  // const handelCrawl = async () => {
  //   const fullURL = `${protocol}://${link}`;
  //   const uuid = uuidv4();

  //   const urlPattern =
  //     /^(http|https):\/\/([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

  //   if (!urlPattern.test(fullURL)) {
  //     alert("Please enter a valid URL");
  //     return;
  //   }

  //   try {
  //     const res = await GetCrawlLink(fullURL);

  //     if (res?.error) {
  //       toast.error("Error fetching crawl data.");
  //       return;
  //     }

  //     console.log(res.data);

  //     if (res?.data?.length > 0) {
  //       // dispatch({
  //       //   type: "setUrls",
  //       //   payload: {
  //       //     type: "crawl",
  //       //     domain: fullURL,
  //       //     data: res.data,
  //       //     uuid: uuid,
  //       //   },
  //       // });

  //       dispatch({
  //         type: "UPDATE_BOT_RESOURCE",
  //         payload: {
  //           botId: bot_id,
  //           data: {
  //             urls: [
  //               ...(botData?.urls || []),
  //               { type: "crawl", domain: fullURL, uuid: uuid, data: res?.data },
  //             ],
  //           },
  //         },
  //       });
  //       setLink("");
  //     } else {
  //       const process = await ProcessCrawlDmain(fullURL, uuid, bot_id);

  //       if (process?.error) {
  //         toast.error("Server error. Please try again later.");
  //       } else {
  //         // dispatch({
  //         //   type: "setUrls",
  //         //   payload: {
  //         //     type: "crawl",
  //         //     domain: fullURL,
  //         //     data: res?.data,
  //         //     load: true,
  //         //     uuid: uuid,
  //         //   },
  //         // });

  //         dispatch({
  //           type: "UPDATE_BOT_RESOURCE",
  //           payload: {
  //             botId: bot_id,
  //             data: {
  //               urls: [
  //                 ...(botData?.urls || []),
  //                 {
  //                   type: "crawl",
  //                   domain: fullURL,
  //                   data: res?.data,
  //                   load: true,
  //                   uuid: uuid,
  //                 },
  //               ],
  //             },
  //           },
  //         });

  //         dispatch({
  //           type: "setTask",
  //           payload: {
  //             process: [...(state?.task?.process || [])],
  //             crawl: [
  //               ...(state?.task?.crawl || []),
  //               {
  //                 type: "crawl",
  //                 status: "progress",
  //                 domain: fullURL,
  //                 data: res?.data,
  //                 uuid: uuid,
  //               },
  //             ],
  //           },
  //         });
  //         setLink("");
  //         toast.success(
  //           "Domain processing started. Try again in a few moments."
  //         );
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Unexpected error:", error);
  //     toast.error("Something went wrong. Please try again.");
  //   }
  // };

  const handelCrawl = async () => {
    const fullURL = `${protocol}://${link}`;
    const uuid = uuidv4();

    const urlPattern =
      /^(http|https):\/\/([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

    if (!urlPattern.test(fullURL)) {
      toast.error("Please enter a valid URL");
      return;
    }

    try {
      const res = await GetCrawlLink(fullURL);

      if (res?.error) {
        toast.error("Error fetching crawl data.");
        return;
      }

      // remove duplicates by domain
      const existingUrls = botData?.urls || [];
      const uniqueUrls = existingUrls.filter((item) => item.domain !== fullURL);

      const newUrlObj = {
        type: "crawl",
        domain: fullURL,
        uuid,
        data: res?.data || [],
      };

      if (res?.data?.length > 0) {
        // Immediate crawl data available
        dispatch({
          type: "UPDATE_BOT_RESOURCE",
          payload: {
            botId: bot_id,
            data: {
              urls: [...uniqueUrls, newUrlObj],
            },
          },
        });
        setLink("");
      } else {
        // Needs backend processing
        const process = await ProcessCrawlDmain(fullURL, uuid, bot_id);

        if (process?.error) {
          toast.error("Server error. Please try again later.");
        } else {
          dispatch({
            type: "UPDATE_BOT_RESOURCE",
            payload: {
              botId: bot_id,
              data: {
                urls: [
                  ...uniqueUrls,
                  {
                    ...newUrlObj,
                    load: true,
                  },
                ],
              },
            },
          });

          dispatch({
            type: "setTask",
            payload: {
              crawl: [
                ...(state?.task?.crawl || []),
                {
                  type: "crawl",
                  status: "progress",
                  domain: fullURL,
                  uuid,
                },
              ],
              process: state?.task?.process || {},
            },
          });

          setLink("");
          toast.success(
            "Domain processing started. Try again in a few moments."
          );
        }
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      await CatchCrawlRes(bot_id, fullURL);
    }
  };

  const handelSiteMap = () => {
    const fullURL = `${protocol}://${link}`;
    const urlPattern =
      /^(http|https):\/\/([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

    if (!urlPattern.test(fullURL)) {
      alert("Please enter a valid URL");
      return;
    }
    const data = fetchSitemapUrls(fullURL);

    console.log("xml", data);
    // dispatch({
    //   type: "setUrls",
    //   payload: { type: "crawl", domain: fullURL, data },
    // });

    dispatch({
      type: "UPDATE_BOT_RESOURCE",
      payload: {
        botId: bot_id,
        data: {
          urls: [
            ...(botData?.urls || []),
            {
              type: "crawl",
              domain: fullURL,
              data: data,
              load: true,
            },
          ],
        },
      },
    });
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    // Add sort logic if needed
  };

  const filteredAndSortedUrls = useMemo(() => {
    if (!botData?.urls) return [];

    let filtered = [];

    // Step 1: Filter by searchTerm
    if (searchTerm.trim() !== "") {
      filtered = botData.urls
        .map((urlObj) => {
          const { data } = urlObj;

          if (Array.isArray(data)) {
            const matched = data.filter((ele) =>
              ele?.toLowerCase()?.includes(searchTerm.toLowerCase())
            );
            if (matched.length > 0) {
              return {
                ...urlObj,
                data: matched,
              };
            }
          } else if (
            typeof data === "string" &&
            data.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return { ...urlObj };
          }

          return null;
        })
        .filter(Boolean); // Remove nulls
    } else {
      filtered = [...(botData?.urls || [])]; // No search term, return all
    }

    // Step 2: Deep clone before sorting
    const sorted = filtered.map((item) => ({
      ...item,
      data: Array.isArray(item.data) ? [...item.data] : item.data,
    }));

    // Step 3: Sort the internal `data` arrays or items
    switch (sortOption) {
      case "atoz":
        sorted.forEach((item) => {
          if (Array.isArray(item.data)) {
            item.data.sort((a, b) => a.localeCompare(b));
          }
        });
        break;

      case "ztoa":
        sorted.forEach((item) => {
          if (Array.isArray(item.data)) {
            item.data.sort((a, b) => b.localeCompare(a));
          }
        });
        break;

      case "used": {
        const usedSet = new Set(
          botData?.usedDocs
            ?.filter((ele) => ele?.type === "html")
            ?.map((doc) => doc?.key_or_urls)
        );

        sorted.sort((a, b) => {
          const aUsed = Array.isArray(a.data)
            ? a.data.some((url) => usedSet.has(url))
            : usedSet.has(a.data);

          const bUsed = Array.isArray(b.data)
            ? b.data.some((url) => usedSet.has(url))
            : usedSet.has(b.data);

          return Number(bUsed) - Number(aUsed); // true-false → 1-0
        });
        break;
      }

      case "nottrained":
        sorted.sort((a, b) => {
          return (
            (a.trained === false ? -1 : 1) - (b.trained === false ? -1 : 1)
          );
        });
        break;

      default:
        break;
    }

    return sorted;
  }, [botData?.urls, botData?.usedDocs, searchTerm, sortOption]);

  const toggleSelectAll = (e) => {
    const isChecked = e.target.checked;

    // Gather all eligible URLs if checkbox is checked
    const selected = isChecked
      ? filteredAndSortedUrls.reduce((acc, ele) => {
          if (ele?.type === "crawl" && !ele.load && Array.isArray(ele.data)) {
            return [...acc, ...ele.data];
          }
          return acc;
        }, [])
      : [];

    dispatch({
      type: "UPDATE_BOT_RESOURCE",
      payload: {
        botId: bot_id,
        data: {
          selectedUrls: isChecked ? selected : [], // if unchecked, clear all selected
        },
      },
    });
  };

  const toggleSelect = (url) => {
    if (botData?.selectedUrls?.includes(url)) {
      dispatch({
        type: "UPDATE_BOT_RESOURCE",
        payload: {
          botId: bot_id,
          data: {
            selectedUrls: botData?.selectedUrls?.filter((u) => u !== url) || [],
          },
        },
      });
      // dispatch({
      //   type: "setSelectedUrls",
      //   payload: state?.selectedUrls?.filter((u) => u !== url),
      // });
    } else {
      dispatch({
        type: "UPDATE_BOT_RESOURCE",
        payload: {
          botId: bot_id,
          data: {
            selectedUrls: [...(botData?.selectedUrls || []), url],
          },
        },
      });
      // dispatch({
      //   type: "setSelectedUrls",
      //   payload: [...state?.selectedUrls, url],
      // });
    }
  };

  const isAllSelected = (() => {
    const allSelectableUrls = filteredAndSortedUrls.reduce((acc, ele) => {
      if (ele?.type === "crawl" && !ele.load && Array.isArray(ele.data)) {
        return [...acc, ...ele.data];
      }
      return acc;
    }, []);

    return (
      allSelectableUrls.length > 0 &&
      allSelectableUrls.every((url) => botData?.selectedUrls?.includes(url))
    );
  })();

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validPdfs = files.filter(isPDF);
    console.log("validPdfs", validPdfs);
    if (validPdfs.length) {
      // dispatch({
      //   type: "setPdfFiles",
      //   payload: [...state.pdfFiles, ...validPdfs],
      // });

      dispatch({
        type: "UPDATE_BOT_RESOURCE",
        payload: {
          botId: bot_id,
          data: {
            pdfFiles: [...(botData.pdfFiles || []), ...validPdfs],
          },
        },
      });
    } else {
      alert("Please upload valid PDF files.");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const files = Array.from(e.dataTransfer.files);
    const validPdfs = files.filter(isPDF);
    if (validPdfs.length) {
      // dispatch({
      //   type: "setPdfFiles",
      //   payload: [...state.pdfFiles, ...validPdfs],
      // });

      dispatch({
        type: "UPDATE_BOT_RESOURCE",
        payload: {
          botId: bot_id,
          data: {
            pdfFiles: [...(botData.pdfFiles || []), ...validPdfs],
          },
        },
      });
    } else {
      alert("Please drop valid PDF files.");
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };

  const removeFile = (index) => {
    const fill_data = botData?.pdfFiles?.filter((_, i) => i !== index);
    // dispatch({
    //   type: "setPdfFiles",
    //   payload: fill_data || [],
    // });

    dispatch({
      type: "UPDATE_BOT_RESOURCE",
      payload: {
        botId: bot_id,
        data: {
          pdfFiles: fill_data || [],
        },
      },
    });
  };

  const handelIndividualPdfLink = () => {
    const fullURL = `${protocol}://${link}`;
    const urlPattern =
      /^(http|https):\/\/([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

    if (!urlPattern.test(fullURL)) {
      alert("Please enter a valid URL");
      return;
    }

    // dispatch({
    //   type: "setPdfurls",
    //   payload: [...(state?.pdfUrls || []), fullURL],
    // });

    dispatch({
      type: "UPDATE_BOT_RESOURCE",
      payload: {
        botId: bot_id,
        data: {
          pdfUrls: [...(botData?.pdfUrls || []), fullURL],
        },
      },
    });

    setLink("");
    return;
  };

  const RemoveIndividualPdfLink = (ide) => {
    const data = botData?.pdfUrls?.filter((item, index) => index !== ide);

    dispatch({
      type: "UPDATE_BOT_RESOURCE",
      payload: {
        botId: bot_id,
        data: {
          pdfUrls: [...(data || [])],
        },
      },
    });
    // dispatch({
    //   type: "setPdfurls",
    //   payload: [...(data || [])],
    // });
  };

  const handelRemoveUrls = async (ide) => {
    const toRemove = botData?.urls?.[ide];

    if (!toRemove) {
      console.warn("Invalid index passed to handelRemoveUrls");
      return;
    }

    const data = botData?.urls?.filter((_, index) => index !== ide);

    dispatch({
      type: "UPDATE_BOT_RESOURCE",
      payload: {
        botId: bot_id,
        data: {
          urls: data || [],
        },
      },
    });

    if (toRemove?.type === "crawl" && toRemove?.domain) {
      try {
        await RemoveCatchCrawlRes(bot_id, toRemove.domain);
      } catch (err) {
        console.error("Unexpected error in RemoveCatchCrawlRes:", err);
      }
    }
  };

  const [selectedValue, setSelectedValue] = useState("html");

  useEffect(() => {
    activeTool === "website"
      ? setSelectedValue("html")
      : setSelectedValue(activeTool?.toLowerCase());
  }, [activeTool]);

  return (
    <div className="w-full flex flex-col">
      {activeTool === "website" && (
        <div className="flex flex-col w-full  gap-3">
          <div className="p-4 flex  flex-col gap-3 border rounded-md">
            <div>
              <h6 className="font-semibold">Link</h6>
              <p className="text-sm text-gray-600">
                Crawl specific web pages or submit sitemaps to continuously
                update your AI with the latest content. Configure included and
                excluded paths to refine what your AI learns.
              </p>
            </div>

            <div className="flex gap-2">
              {modes?.map(({ key, label }) => (
                <button
                  key={key}
                  className={`px-3 py-1 relative underline-animate ${
                    mode.link === key ? "active" : ""
                  }`}
                  onClick={() => setMode((prv) => ({ ...prv, link: key }))}>
                  {label}
                </button>
              ))}
            </div>

            {mode.link === "link" && (
              <div className="flex flex-col items-end mt-4 gap-1">
                <span className="w-full font-semibold">URL:</span>
                <div className="flex w-full items-center border border-gray-300 rounded-md overflow-hidden">
                  <select
                    value={protocol}
                    onChange={(e) => setProtocol(e.target.value)}
                    className="px-3 py-2 bg-white focus:outline-none">
                    <option value="https">https://</option>
                    <option value="http">http://</option>
                  </select>
                  <div className="w-px h-6 bg-gray-300 mx-1" />
                  <input
                    type="text"
                    placeholder="www.example.com"
                    value={link}
                    onChange={(e) => handleInputChange(e)}
                    className="flex-1 px-3 py-2 focus:outline-none"
                  />
                </div>
                <button
                  onClick={handelIndividualLink}
                  className="bg-black w-fit text-white px-6 py-2 mt-2 rounded-md hover:bg-gray-800 transition">
                  Add
                </button>
              </div>
            )}

            {mode.link === "crawl" && (
              <div className="flex flex-col items-end mt-4 gap-1">
                <span className="w-full font-semibold">Domain:</span>
                <div className="flex w-full items-center border border-gray-300 rounded-md overflow-hidden">
                  <select
                    value={protocol}
                    onChange={(e) => setProtocol(e.target.value)}
                    className="px-3 py-2 bg-white focus:outline-none">
                    <option value="https">https://</option>
                    <option value="http">http://</option>
                  </select>
                  <div className="w-px h-6 bg-gray-300 mx-1" />
                  <input
                    type="text"
                    placeholder="www.example.com"
                    value={link}
                    onChange={(e) => handleInputChange(e)}
                    className="flex-1 px-3 py-2 focus:outline-none"
                  />
                </div>
                <div className="text-sm flex items-start justify-center gap-2   ">
                  <IoInformationCircleOutline size={18} className="mt-1" /> If
                  you add multiple crawl links, they will all be marked as
                  "pending" and will not overwrite one another.
                </div>
                <button
                  onClick={handelCrawl}
                  disabled={link.length === 0}
                  className={`bg-black w-fit text-white px-6 py-2 mt-2 rounded-md hover:bg-gray-800 transition ${
                    link.length === 0 ? "cursor-not-allowed opacity-50" : ""
                  }`}>
                  Fetch Links
                </button>
              </div>
            )}

            {mode.link === "sitemap" && (
              <div className="flex flex-col items-end mt-4 gap-1">
                <span className="w-full font-semibold">URL:</span>
                <div className="flex w-full items-center border border-gray-300 rounded-md overflow-hidden">
                  <select
                    value={protocol}
                    onChange={(e) => setProtocol(e.target.value)}
                    className="px-3 py-2 bg-white focus:outline-none">
                    <option value="https">https://</option>
                    <option value="http">http://</option>
                  </select>
                  <div className="w-px h-6 bg-gray-300 mx-1" />
                  <input
                    type="text"
                    placeholder="www.example.com"
                    value={link}
                    onChange={(e) => handleInputChange(e)}
                    className="flex-1 px-3 py-2 focus:outline-none"
                  />
                </div>
                <div className="text-sm flex items-start justify-center gap-2   ">
                  <IoInformationCircleOutline size={18} className="mt-1" /> If
                  you add multiple crawl links, they will all be marked as
                  "pending" and will not overwrite one another.
                </div>
                <button
                  onClick={handelSiteMap}
                  className="bg-black w-fit text-white px-6 py-2 mt-2 rounded-md hover:bg-gray-800 transition">
                  Fetch Links
                </button>
              </div>
            )}
          </div>

          <div className="p-4 border rounded-md flex flex-col">
            {/* Header and Search */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <h4 className="text-lg font-semibold">Link Sources</h4>
              <input
                type="search"
                placeholder="Search"
                className="border px-3 py-1 rounded-md w-full sm:w-1/2"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Select All and Sort Options */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between my-2 gap-2">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={toggleSelectAll}
                />
                <span className="text-sm">Select All</span>
              </label>
              <select
                value={sortOption}
                onChange={handleSortChange}
                className="border px-3 py-1 rounded-md w-full sm:w-40">
                <option value="atoz">A-Z</option>
                <option value="ztoa">Z-A</option>
                <option value="used">Used</option>
                <option value="nottrained">Not Trained</option>
              </select>
            </div>

            {filteredAndSortedUrls?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="px-4 py-2 border text-sm rounded shadow-sm bg-white hover:shadow-md transition-shadow">
                  {(item.type === "crawl" || item.type === "sitemap") && (
                    <>
                      <div className="flex justify-between items-start w-full mb-2">
                        <div className="flex items-center gap-2 text-gray-800">
                          <FiGlobe
                            size={18}
                            className="text-gray-500 mt-[2px]"
                          />
                          <span className="italic text-darkprimary break-all text-sm">
                            {item.domain}
                          </span>
                        </div>

                        {!!item.load ? (
                          <span className="text-xs text-green-400">
                            <ImSpinner2 size={24} className="animate-spin" />
                          </span>
                        ) : (
                          <button
                            onClick={() => handelRemoveUrls(index)}
                            className="text-red-500 text-xs hover:underline">
                            Remove
                          </button>
                        )}
                      </div>
                      {!item.load && (
                        <div className="w-full mb-2 text-gray-500">
                          Total links: {item?.data?.length}
                        </div>
                      )}

                      {!item.load && (
                        <InfiniteScrollUrls
                          usedDocs={botData?.usedDocs?.filter(
                            (ele) => ele?.type === "html"
                          )}
                          allUrls={item.data}
                          selectedUrls={botData?.selectedUrls || []}
                          toggleSelect={toggleSelect}
                        />
                      )}
                    </>
                  )}

                  {item.type === "individual" && (
                    <div className="flex justify-between items-center ">
                      <div className="text-gray-600 italic flex gap-2 items-center">
                        <IoLinkSharp size={20} /> <span>{item.data}</span>
                      </div>
                      <button
                        onClick={() => handelRemoveUrls(index)}
                        className="text-red-500 text-xs hover:underline">
                        Remove
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {activeTool === "text" && (
        <div className="flex flex-col gap-3">
          <div className="p-4 flex flex-col gap-3 border rounded-md w-full">
            <div>
              <h6 className="font-semibold">Text</h6>
              <p className="text-sm text-gray-600">
                Add and process plain text-based sources to train your AI Agent
                with precise information.
              </p>
            </div>

            <div className="flex flex-col mt-4 gap-3">
              <label className="w-full">
                <span className="text-sm font-medium">state.title</span>
                <input
                  type="text"
                  placeholder="E.g. “The Day the Rabbit Found Magic”"
                  value={botData?.title || ""}
                  onChange={(e) =>
                    // dispatch({ type: "setTitle", payload: e.target.value })

                    {
                      e.preventDefault();
                      dispatch({
                        type: "UPDATE_BOT_RESOURCE",
                        payload: {
                          botId: bot_id,
                          data: {
                            title: e.target.value,
                          },
                        },
                      });
                    }
                  }
                  className="w-full px-3 py-2 border rounded-md mt-1 focus:outline-none focus:ring-1 focus:ring-black"
                />
              </label>

              <label className="w-full">
                <span className="text-sm font-medium">Text</span>
                <textarea
                  placeholder="Once upon a time, a curious rabbit named Nibble lived in a quiet meadow.  
He loved exploring the forest, hopping over streams and under logs.  
One day, he discovered a glowing carrot buried in the ground.  
Nibble took a bite, and suddenly he could understand all the forest animals.  
From that day on, he became the wisest creature in the woods...
"
                  value={botData?.text || ""}
                  onChange={(e) =>
                    // dispatch({ type: "setText", payload: e.target.value })

                    {
                      e.preventDefault();
                      dispatch({
                        type: "UPDATE_BOT_RESOURCE",
                        payload: {
                          botId: bot_id,
                          data: {
                            text: e.target.value,
                          },
                        },
                      });
                    }
                  }
                  className="w-full px-3 py-2 min-h-[14rem] border rounded-md mt-1 focus:outline-none focus:ring-1 focus:ring-black resize-none"
                  rows={10}
                />
              </label>
            </div>
          </div>
        </div>
      )}

      {activeTool === "pdf" && (
        <div className="flex w-full flex-col gap-3">
          <div className="p-4 flex flex-col gap-3 border rounded-md w-full">
            <div>
              <h6 className="font-semibold">PDF</h6>
              <p className="text-sm text-gray-600">
                The Files tab allows you to upload and manage various pdfs to
                train your AI agent.
              </p>
            </div>
            <div className="flex gap-2">
              {pdf_modes &&
                pdf_modes?.map(({ key, label }) => (
                  <button
                    key={key}
                    className={`px-3 py-1 relative underline-animate ${
                      mode.pdf === key ? "active" : ""
                    }`}
                    onClick={() => setMode((prv) => ({ ...prv, pdf: key }))}>
                    {label}
                  </button>
                ))}
            </div>

            {mode.pdf === "pdf" && (
              <div className="flex flex-col items-end mt-4 gap-2 w-full">
                {/* Drop Zone and File Input */}
                <div
                  className={`w-full p-4 h-36 border-2 rounded-md border-dashed transition ${
                    dragActive
                      ? "border-blue-500 bg-blue-50"
                      : "border-gray-300"
                  }`}
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}>
                  <label
                    htmlFor="pdf-upload"
                    className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                    <HiOutlineUpload size={24} />
                    <p className="text-gray-600 mt-2 text-sm">
                      Drag and drop PDF files here or click to upload
                    </p>
                    <input
                      id="pdf-upload"
                      type="file"
                      accept="application/pdf"
                      multiple
                      onChange={handleFileChange}
                      className="hidden"
                    />
                  </label>
                </div>

                {/* File List */}
                {botData?.pdfFiles?.length > 0 && (
                  <ul className="w-full text-sm text-gray-700 mt-1 max-h-40 overflow-auto border rounded p-2 bg-white">
                    {botData?.pdfFiles &&
                      botData?.pdfFiles?.map((file, index) => (
                        <li
                          key={index}
                          className="flex justify-between items-center py-1 border-b last:border-none">
                          <span className="truncate">{file.name}</span>
                          <button
                            onClick={() => removeFile(index)}
                            className="text-red-500 text-xs hover:underline">
                            Remove
                          </button>
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            )}

            {mode.pdf === "link" && (
              <div className="flex flex-col items-end mt-4 gap-1">
                <span className="w-full font-semibold">URL:</span>
                <div className="flex w-full items-center border border-gray-300 rounded-md overflow-hidden">
                  <select
                    value={protocol}
                    onChange={(e) => setProtocol(e.target.value)}
                    className="px-3 py-2 bg-white focus:outline-none">
                    <option value="https">https://</option>
                    <option value="http">http://</option>
                  </select>
                  <div className="w-px h-6 bg-gray-300 mx-1" />
                  <input
                    type="text"
                    placeholder="www.example.com/demo.pdf"
                    value={link}
                    onChange={(e) => handleInputChange(e)}
                    className="flex-1 px-3 py-2 focus:outline-none"
                  />
                </div>
                <button
                  onClick={handelIndividualPdfLink}
                  className="bg-black w-fit text-white px-6 py-2 mt-2 rounded-md hover:bg-gray-800 transition">
                  Add
                </button>
              </div>
            )}
          </div>
          {botData?.pdfUrls && botData?.pdfUrls?.length > 0 && (
            <div className="space-y-2 mt-2">
              {botData?.pdfUrls?.map((url, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center bg-gray-100 px-3 py-2 rounded shadow-sm">
                  <div className="text-sm text-gray-700 truncate max-w-xs">
                    {url}
                  </div>
                  <button
                    onClick={() => RemoveIndividualPdfLink(index)}
                    className="text-red-600 text-xs font-medium hover:underline">
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <button
        disabled={false}
        onClick={handelTrain}
        className="text-white bg-gray-900 hover:bg-black px-10 py-3 md:hidden mt-2  rounded-lg shadow-smd cursor-not-allowed
 ">
        {" "}
        Retrain Bot
      </button>

      {!!botData?.usedDocs && botData?.usedDocs?.length > 0 && (
        <div className="w-full mt-6">
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-xl font-bold text-gray-800">Used Resources</h1>
            <select
              className="border border-gray-300 text-sm px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedValue}
              onChange={(e) => setSelectedValue(e.target.value)}>
              <option value="html">Links</option>
              <option value="pdf">PDFs</option>
              <option value="text">Text</option>
            </select>
          </div>

          <div className="bg-white shadow-md rounded-lg p-4">
            <InfiniteScrollForUsedUrls
              allUrls={botData?.usedDocs?.filter(
                (ele) => ele?.type === selectedValue
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ActiveTool;
